import styled from 'styled-components/macro';
import { ProgressTabsDiv, TabH5 } from '../../../components/ProgressTabStyles';

export const SubNavTabsDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SalesMaterialContainerDiv = styled.div`
  display: flex;
  margin-top: 3rem;
  @media screen and (min-width: 768px) {
    margin-top: 5rem;
  }
  ${ProgressTabsDiv} {
    min-height: 500px;
    display: flex;
    position: relative;
    /* padding-top: 3rem; */
    padding-top: 0;
    flex-direction: column;
    border-right: ${props => props.theme.defaultBorder};
    @media screen and (min-width: 768px) {
      /* padding-top: 3rem; */
      flex-direction: column;
      border-right: ${props => props.theme.defaultBorder};
    }
    @media screen and (max-width: 767px) {
      border-bottom: none;
    }
  }
  ${TabH5} {
    border-bottom: 2px solid transparent;
    text-align: right;
  }
`;

export const MerchantSalesMaterialsDiv = styled.div`
  padding-left: 25px;
  @media screen and (min-width: 768px) {
    padding-left: 50px;
  }
  padding-top: 50px;
  position: relative;
`;

export const SalesFiltersDiv = styled.div`
  position: absolute;
  top: 0px;
  z-index: 100;
`;

export const SalesMaterialDiv = styled.div``;
